// cSpell: disable

const iConsole = `
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWXOxxOXWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMNKxl,....,lxKWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMWXOo:'';lxOOxl;'':dOXWMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMWKxl,.':dOKNNNNNNKOd:'.,lkKWMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMWXOd:'';lx0XNNNNNNNNNNNNX0xl;'':dONWMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMWKkl;'':oOKNNNNNNNNNNNNNNNNNNNXKko:'';lkKWMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMWN0d:'',lx0XNNNNNNNNNNNNNNNNNNNNNNNNNNX0xl,.'cdONWMMMMMMMMMMMMMMM
MMMMMMMMMMMMWKkl;'':okKXNNNNNNNNNNNNNNWWWWNNNNNNNNNNNNNNXKko:'';lkKWMMMMMMMMMMMM
MMMMMMMMMN0dc,.,cx0XNNNNNNNNNNNNNNWWWMMMMMMMWWNNNNNNNNNNNNNNX0dc,',cd0NMMMMMMMMM
MMMMMWXko;'':okKXNNNNNNNNNNNNNNWWMMMMMMMMMMMMMMWWNNNNNNNNNNNNNNXKko:'';okXWMMMMM
MMMMM0:..;dOXNNNNNNNNNNNNNNWWMMMMMMMMMMMMMMMMMMMMMMWWNNNNNNNNNNNNNNXOd;..:0MMMMM
MMMMMO'..,cdOXNNNNNNNNNNWWMMMMMMMMMMMMMMMMMMMMMMMMMMMMWWNNNNNNNNNNXOdc'..,OMMMMM
MMMMMO'.....';okKXNNWWWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWWNNXKko;'.....,OMMMMM
MMMMMO'.........,d.KWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWK0d;.........,OMMMMM
MMMMMO'..........oK0.0KNWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWNK0.0Kd..........,OMMMMM
MMMMMO'..........dWMWNK0.0XWMMMMMMMMMMMMMMMMMMMMMMMMWX0.0KNWMWx..........,OMMMMM
MMMMMO'..........dWMMMMMNK0.0KNMMMMMMMMMMMMMMMMMMNK0.0KNMMMMMWx..........,OMMMMM
MMMMMO'..........dWMMMMMMMMWNK0.0XWMMMMMMMMMMWX0.0KNWMMMMMMMMWx..........,OMMMMM
MMMMMO'..........dWMMMMMMMMMMMMNK0.0KNMMMWNK0.0KNMMMMMMMMMMMMMx..........,OMMMMM
MMMMMO'..........dWMMMMMMMMMMMMMMMWXK00..00KXWMMMMMMMMMMMMMMMMx..........,OMMMMM
MMMMMO'..........dWMMMMMMMMMMMMMMMMMMMKxxKMMMMMMMMMMMMMMMMMMMMx..........,OMMMMM
MMMMMO'..........dWMMMMMMMMMMMMMMMMMMMXxxXMMMMMMMMMMMMMMMMMMMMx..........,OMMMMM
MMMMMO'..........dWMMMMMMMMMMMMMMMMMMMXxxXMMMMMMMMMMMMMMMMMMMMk'.........,OMMMMM
MMMMMO'....':okKXNNNNWWMMMMMMMMMMMMMMMXxxXMMMMMMMMMMMMMMN0dc'............,OMMMMM
MMMMMO'..:x0XNNNNNNNNNNNWWWMMMMMMMMMMMXxxXMMMMMMMMMMWKkl;................,OMMMMM
MMMMMKc..;okKXNNNNNNNNNNNNNNWWMMMMMMMMXxxXMMMMMMWN0dc'...................cKMMMMM
MMMMMWN0xc,.,cdOXNNNNNNNNNNNNNNWWWMMMMXxxXMMMWKkl;...................,cx0NWMMMMM
MMMMMMMMMWXko;'':okKXNNNNNNNNNNNNNNWWMXxxKN0dc'...................;okXWMMMMMMMMM
MMMMMMMMMMMMWN0dc,',cd0XNNNNNNNNNNNNNNKo:c;...................,cd0NWMMMMMMMMMMMM
MMMMMMMMMMMMMMMMWKkl;'':okKXNNNNNNNNNN0:...................;lkXWMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMN0d:'',lx0XNNNNNNN0:...............'cd0NWMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMWKkl;'':okKNNNN0:............;lkKWMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMWNOd:'';lx0X0:........':dONWMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWKxl,.':c,.....,lkKWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMWXOd:'..':dOXWMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMNOddONMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM

.------------------------------------------------------------------------------.
|                                                                              |
|                       Welcome to TheIceJI Website . . .                      |
|                                                                              |
'------------------------------------------------------------------------------'
`;
export default iConsole;